// Will be deleted after release
// export default {
//   mounted (el, binding) {
//     const targetId = binding.value
//     el.addEventListener('click', () => {
//       const target = document.getElementById(targetId)
//       if (!target) {
//         console.error(`v-toggle-collapse, ID tidak ditemukan: "${targetId}".`)
//         return
//       }
//       el.classList.toggle('not-collapsed')
//       target.classList.toggle('show')
//     })
//   },
//   beforeUnmount (el) {
//     el.removeEventListener('click', () => {})
//   }
// }

export default {
  mounted (el, binding) {
    const targetId = binding.value

    // Define the toggle behavior
    const toggle = () => {
      console.log(targetId, 'emit')
      const target = document.getElementById(targetId)
      if (!target) {
        console.error(`v-toggle-collapse: ID not found "${targetId}".`)
        return
      }
      el.classList.toggle('not-collapsed')
      target.classList.toggle('show')
    }

    // Save the handler for cleanup
    el.__toggleHandler = toggle

    // Add a click event listener
    el.addEventListener('click', toggle)

    // Listen for global events via the event bus
    const eventName = `v-toggle-collapse:${targetId}`
    const emitter = binding.instance.$root.emitter // Access the global emitter
    if (!emitter) {
      console.error('Event bus (emitter) not found in global properties.')
      return
    }

    const eventHandler = () => toggle()
    emitter.on(eventName, eventHandler)

    // Save the event handler for cleanup
    el.__eventHandler = { eventName, emitter, eventHandler }
  },
  beforeUnmount (el) {
    // Remove the click event listener
    if (el.__toggleHandler) {
      el.removeEventListener('click', el.__toggleHandler)
      delete el.__toggleHandler
    }

    // Remove the global event listener
    if (el.__eventHandler) {
      const { eventName, emitter, eventHandler } = el.__eventHandler
      emitter.off(eventName, eventHandler)
      delete el.__eventHandler
    }
  }
}
